import { useState } from "react";
import dayjs from "dayjs";

import SectionContainer from "../container/SectionContainer";
import {
	Button,
	ColorV2,
	InputBirthday,
	Modal,
	Text,
} from "@adoptaunabuelo/react-components";
import { UserScheme, User } from "client-v2";
import { State } from "../../redux";
import { useSelector } from "react-redux";

const BirthStep = (props: Props) => {
	const isMobile = useSelector((state: State) => state.screen.isMobile);
	const translation = useSelector(
		(state: State) => state.location.translation
	);
	const colors = {
		buttonBackground: ColorV2.surface.primary,
		buttonColor: "white",
		animation: ["#00315C", "#005AA8"],
	};

	const [date, setDate] = useState<Date | undefined>(undefined);
	const [inputError, setInputError] = useState<string>("");
	const [loading, setLoading] = useState(false);
	const [showModal, setShowModal] = useState(false);

	const onInputChange = (date: any) => {
		setInputError("");
		setDate(date);
	};

	const onNextClick = () => {
		if (date) {
			//Check if volunteer is in the year margin
			setShowModal(false);
			const today = dayjs();
			const momentDate = dayjs(date);

			if (today.diff(momentDate, "years") < 15) {
				setInputError(
					"Para unirte a Adopta Un Abuelo debes ser mayor de 15 años."
				);
				return undefined;
			} else if (today.diff(momentDate, "years") > 150) {
				setInputError(
					"Asegúrate de que el año introducido es correcto."
				);
				return undefined;
			}

			setInputError("");

			setLoading(true);
			User.set(props.user.objectId, {
				birthday: momentDate.toDate(),
			})
				.then((result) => {
					setLoading(false);
					props.onFinish({ data: result.data });
				})
				.catch((error) => {
					setLoading(false);
					props.onFinish({ error: error.message });
				});
		} else {
			setInputError(
				"Introduce una fecha válida con el formato DD MM AAAA."
			);
		}
	};

	return (
		<SectionContainer
			title="Tu fecha de nacimiento"
			subtitle="Conocer tu edad nos ayudará a conectarte con tu abuelo."
			buttonProps={{
				style: {
					backgroundColor: colors.buttonBackground,
					color: colors.buttonColor,
				},
				loading: loading,
				children: translation.component_button_next,
				onClick: () => setShowModal(true),
			}}
		>
			<Modal
				isVisible={showModal}
				hideClose={true}
				type={isMobile ? "full-screen" : "default"}
				contentStyle={{ padding: "24px 24px 12px" }}
				onClose={() => setShowModal(false)}
			>
				<Text type="p2" style={{ textAlign: "center" }}>
					Solo por confirmar,
				</Text>
				<Text
					type="h4"
					weight="semibold"
					style={{ textAlign: "center", marginBottom: 32 }}
				>
					¿tienes {dayjs().diff(dayjs(date), "years")} años?
				</Text>
				<Button
					style={{ width: "100%" }}
					onClick={() => {
						setShowModal(false);
						onNextClick();
					}}
				>
					Confirmar
				</Button>
				<Button
					style={{
						width: "100%",
						color: ColorV2.text.neutralHard,
						backgroundColor: "transparent",
					}}
					onClick={() => setShowModal(false)}
				>
					Cambiar fecha
				</Button>
			</Modal>
			<InputBirthday
				design={"secondary"}
				error={inputError}
				onChange={onInputChange}
				onKeyDown={() => setInputError("")}
			/>
		</SectionContainer>
	);
};
export default BirthStep;
export interface Props {
	user: UserScheme;
	onFinish: (result: { data?: UserScheme; error?: string }) => void;
}
